/* eslint-disable */

export enum Orientation {
  /** CASH - Money sent using Cash App: the initiator is sending money to the getter. */
  CASH = "CASH",
  /** BILL - A request for money using Cash App: the initiator is requesting money from the getter. */
  BILL = "BILL",
}
